/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Shoe_TypeInputs */

const en_field_shoe_type = /** @type {(inputs: Field_Shoe_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoe Type`)
};

const es_field_shoe_type = /** @type {(inputs: Field_Shoe_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de zapato`)
};

const fr_field_shoe_type = /** @type {(inputs: Field_Shoe_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type de chaussure`)
};

const de_field_shoe_type = /** @type {(inputs: Field_Shoe_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schuhtyp`)
};

const ja_field_shoe_type = /** @type {(inputs: Field_Shoe_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`靴の種類`)
};

const zh_field_shoe_type = /** @type {(inputs: Field_Shoe_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`鞋类`)
};

const ar_field_shoe_type = /** @type {(inputs: Field_Shoe_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نوع الحذاء`)
};

const id_field_shoe_type = /** @type {(inputs: Field_Shoe_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenis Sepatu`)
};

const it_field_shoe_type = /** @type {(inputs: Field_Shoe_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo di Scarpa`)
};

const ru_field_shoe_type = /** @type {(inputs: Field_Shoe_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип обуви`)
};

const pt_field_shoe_type = /** @type {(inputs: Field_Shoe_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de Calçado`)
};

const ko_field_shoe_type = /** @type {(inputs: Field_Shoe_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`신발 종류`)
};

/**
* | output |
* | --- |
* | "Shoe Type" |
*
* @param {Field_Shoe_TypeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_shoe_type = /** @type {((inputs?: Field_Shoe_TypeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Shoe_TypeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_shoe_type(inputs)
	if (locale === "es") return es_field_shoe_type(inputs)
	if (locale === "fr") return fr_field_shoe_type(inputs)
	if (locale === "de") return de_field_shoe_type(inputs)
	if (locale === "ja") return ja_field_shoe_type(inputs)
	if (locale === "zh") return zh_field_shoe_type(inputs)
	if (locale === "ar") return ar_field_shoe_type(inputs)
	if (locale === "id") return id_field_shoe_type(inputs)
	if (locale === "it") return it_field_shoe_type(inputs)
	if (locale === "ru") return ru_field_shoe_type(inputs)
	if (locale === "pt") return pt_field_shoe_type(inputs)
	return ko_field_shoe_type(inputs)
});